import { FC, memo } from "react";
import NoDataImage from "@assets/no-data.jpg";
import "./no-data.scss";

interface NoDataProps {
  className?: string;
  image?: string;
  text?: string;
}
const NoDataComponent: FC<NoDataProps> = ({
  className = "",
  image = NoDataImage,
  text = "No Data available",
}) => {
  return (
    <div className={`no-data-container ${className}`}>
      <div className="no-data-image-area">
        <img src={image} alt="" decoding="async" loading="eager" />
      </div>
      <div className="no-data-text-area">
        <p>{text}</p>
      </div>
    </div>
  );
};

export const NoData = memo(NoDataComponent);
